import React, { useState, useEffect } from 'react';
import api from '../services/api';
import Message from '../components/Message.jsx';

const UserManagement = () => {
  const [users, setUsers] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [formData, setFormData] = useState({
    username: '',
    password: ''
  });
  const [editingId, setEditingId] = useState(null);
  const [message, setMessage] = useState({ text: '', type: '' });

  useEffect(() => {
    loadUsers();
  }, []);

  const loadUsers = async () => {
    try {
      const data = await api.users.getAll();
      setUsers(data);
    } catch (error) {
      setMessage({ text: 'Failed to load users', type: 'error' });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editingId) {
        await api.users.update(editingId, formData);
        setMessage({ text: 'User updated successfully!', type: 'success' });
      } else {
        await api.users.create(formData);
        setMessage({ text: 'User created successfully!', type: 'success' });
      }
      loadUsers();
      resetForm();
    } catch (error) {
      setMessage({ text: 'Failed to save user', type: 'error' });
    }
  };

  const handleEdit = (user) => {
    setFormData({
      username: user.username,
      password: ''
    });
    setEditingId(user.id);
    setShowForm(true);
  };

  const handleDelete = async (id) => {
    if (window.confirm('Delete this user?')) {
      try {
        await api.users.delete(id);
        loadUsers();
        setMessage({ text: 'User deleted successfully!', type: 'success' });
      } catch (error) {
        setMessage({ text: 'Failed to delete user', type: 'error' });
      }
    }
  };

  const resetForm = () => {
    setFormData({ username: '', password: '' });
    setEditingId(null);
    setShowForm(false);
  };

  return (
    <div className="container-fluid">
      {message.text && (
        <Message 
          message={message.text} 
          type={message.type} 
          onClose={() => setMessage({ text: '', type: '' })} 
        />
      )}
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h2>User Management</h2>
        <button className="btn btn-primary" onClick={() => setShowForm(true)}>
          Add User
        </button>
      </div>

      {showForm && (
        <div className="card mb-4">
          <div className="card-body">
            <h5>{editingId ? 'Edit User' : 'Add New User'}</h5>
            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-md-5">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Username *"
                    value={formData.username}
                    onChange={(e) => setFormData({...formData, username: e.target.value})}
                    required
                  />
                </div>
                <div className="col-md-5">
                  <input
                    type="password"
                    className="form-control"
                    placeholder="Password *"
                    value={formData.password}
                    onChange={(e) => setFormData({...formData, password: e.target.value})}
                    required={!editingId}
                  />
                </div>
                <div className="col-md-2">
                  <button type="submit" className="btn btn-success me-2">Save</button>
                  <button type="button" className="btn btn-secondary" onClick={resetForm}>Cancel</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      )}

      <div className="card">
        <div className="card-body">
          <table className="table">
            <thead>
              <tr>
                <th>ID</th>
                <th>Username</th>
                <th>Status</th>
                <th>Created</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {users.map(user => (
                <tr key={user.id}>
                  <td>{user.id}</td>
                  <td>{user.username}</td>
                  <td>
                    <span className={`badge ${user.status ? 'bg-success' : 'bg-danger'}`}>
                      {user.status ? 'Active' : 'Inactive'}
                    </span>
                  </td>
                  <td>{new Date(user.createdAt).toLocaleDateString()}</td>
                  <td>
                    <button className="btn btn-sm btn-warning me-2" onClick={() => handleEdit(user)}>
                      Edit
                    </button>
                    <button className="btn btn-sm btn-danger" onClick={() => handleDelete(user.id)}>
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default UserManagement;